import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button-spinner',
  templateUrl: './button-spinner.component.html',
  styleUrls: ['./button-spinner.component.scss']
})
export class ButtonSpinnerComponent implements OnInit {

  @Input() disabled: boolean = false
  @Input() buttonText: string = ''
  @Input() inProgress: boolean = false
  @Input() inProgressText: string = ''
  @Input() color: string = ''

  @Output() buttonClicked = new EventEmitter()

  constructor() { }

  ngOnInit(): void {
  }

  onClick() {
    this.buttonClicked.emit()
  }
}
